<!-- 需求耗时分布 -->
<template>
  <a-card size="small" :bordered="false">
    <template slot="title">
      <span style="margin-right: 4px">需求耗时分布</span>
      <a-popover title="报表说明" placement="topLeft">
        <template slot="content">
          <p>时间: 需求上线时间</p>
          <p>描述: 所选时间段各需求的耗时分布</p>
          <p>&emsp;&emsp;&ensp;研发耗时: 需求从待处理变更为开发中状态 -> 需求从开发中变更为开发完成状态的时长</p>
          <p>&emsp;&emsp;&ensp;质量耗时: 流程从QA环境部署流转至质量验收 -> 流程从质量验收流转至Demo环境部署的时长</p>
          <p>&emsp;&emsp;&ensp;发布耗时: 流程从质量验收流转至Demo环境部署 -> 流程从生产环境部署流转至完成的时长</p>
          <p>排序: 需求耗时总时长正序（默认）</p>
        </template>
        <a-icon type="question-circle" />
      </a-popover>
    </template>
    <div id="task-point-rank" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
import { reqDevTimeRank } from '@/api/data/requirement';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'person',
      myChart: null,
      titleDict: {},
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<div><b>' + params[0].name + '</b><br>';
            formatter += this.titleDict[params[0].name] + '<br>';
            for (let i = 0; i < params.length; i++) {
              formatter += params[i].marker + params[i].seriesName + ': ' + '<span style="color: #00B83F;">' + params[i].value + '</span> 小时 <br>';
            }
            formatter += '</div>';
            return formatter;
          }
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: []
      },
      xAxisData: [],
      series: []
    };
  },
  watch: {
    filterForm() {
      this.getReqDevTimeRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    this.myChart = echarts.init(document.getElementById('task-point-rank'));
    this.getReqDevTimeRank();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getReqDevTimeRank() {
      reqDevTimeRank({ ...this.filterForm, show_modal: this.showModal }).then(res => {
        this.titleDict = res.data.title_dict;
        this.option.xAxis.data = res.data.x_axis;
        this.option.series = [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              formatter: params => (params.value > 0 ? params.value : ' ')
            },
            name: '研发耗时',
            data: res.data.dev_time_series,
            stack: 'cost'
          },
          {
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              formatter: params => (params.value > 0 ? params.value : ' ')
            },
            name: '质量验收耗时',
            data: res.data.qa_time_series,
            stack: 'cost'
          },
          {
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              formatter: params => (params.value > 0 ? params.value : ' ')
            },
            // itemStyle: {
            //   normal: {
            //     color: '#C3C51D'
            //   }
            // },
            name: 'Demo耗时',
            data: res.data.demo_time_series,
            stack: 'cost'
          }
        ];
        this.drawChart();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
